import { styled } from "@linaria/react";
import { MOBILE_MEDIA_QUERY } from "../app/global.linaria.global";


export const LinkButtonBase = styled.a`
	box-sizing: border-box;

	padding: 1rem 2rem;
    border-radius: 50px;
    text-decoration: none !important;
    font-weight: 600;
    color: white !important;
	text-align: center;

    transition: all 0.75s cubic-bezier(0.35, 0.3, 0, 0.89) !important;
    transform: translateY(0);
    box-shadow: none;
    &:hover {
    	transition: all 0.36s cubic-bezier(0.35, 0.3, 0, 0.89) !important;
        transform: translateY(-3px);
    }

    * { color: inherit !important; }
`;

export const PrimaryLinkButton1Blog = styled(LinkButtonBase)`
    background: linear-gradient(45deg, #667eea, #764ba2);;

    &:hover {
        box-shadow: 0 -0.2rem 0.8rem #764ba2a0, -0.2rem 0.75rem 1.2rem #667eea60;
    }

    @media ${MOBILE_MEDIA_QUERY} {
        margin: 1rem 2rem 0;
        display: inline-block;
        width: auto;
    }
`;

export const PrimaryLinkButton2Projects = styled(LinkButtonBase)`
    background: linear-gradient(45deg, #ea6666, #a24ba2);
	text-align: center;

    &:hover {
        box-shadow: 0 -0.2rem 0.8rem #a24ba2a0, 0 0.75rem 1.2rem #ea666640;
    }

    @media ${MOBILE_MEDIA_QUERY} {
        margin: 1rem 2rem 0;
        display: inline-block;
        width: auto;
    }
`;

export const PrimaryLinkButton3Resume = styled(LinkButtonBase)`
    background: linear-gradient(35deg, #6856a8, #3f8ca3);
    color: white !important;

    &:hover {
        box-shadow: 0 -0.2rem 0.8rem #3f8ca3a0, 0.2rem 0.75rem 1.2rem #6856a860;
    }

    @media ${MOBILE_MEDIA_QUERY} {
        margin: 1rem 2rem 0;
        display: inline-block;
        width: auto;
    }
`;

export const SecondaryLinkButton = styled(LinkButtonBase)`
    color: white;
    background: transparent;
    border: 2px solid rgba(255, 255, 255, 0.3);

    &:hover {
        background: rgba(255, 255, 255, 0.1);
        border-color: rgba(255, 255, 255, 0.5);
        transform: translateY(-2px);
    }
`;
